export default "__VITE_ASSET__rLv219hd__"